import { Node, mergeAttributes } from "@tiptap/core";

export const MergeTagNode = Node.create({
  name: "mergeTag",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      tag: { default: null },
      label: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-merge-tag]" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-merge-tag": node.attrs.tag,
        contenteditable: "false",
      }),
      `{{${node.attrs.tag}}}`,
    ];
  },

  addCommands() {
    return {
      insertMergeTag:
        (attrs) =>
        ({ chain }) => {
          return chain()
            .insertContent({ type: this.name, attrs })
            .run();
        },
    };
  },
});
